import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "44",
  height: "44",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M0 22C0 9.85 9.85 0 22 0s22 9.85 22 22-9.85 22-22 22S0 34.15 0 22"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#0B1228",
      "stroke-opacity": ".14",
      "stroke-width": ".5",
      d: "M22 .25C34.012.25 43.75 9.988 43.75 22S34.012 43.75 22 43.75.25 34.012.25 22 9.988.25 22 .25Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#42B2D7",
      d: "M29.457 16.821 27.194 27.43c-.171.749-.616.935-1.25.582l-3.448-2.525-1.665 1.59c-.184.183-.338.336-.693.336l.248-3.49 6.392-5.74c.278-.246-.06-.382-.431-.136l-7.903 4.944-3.402-1.058c-.74-.23-.753-.735.154-1.088l13.307-5.094c.616-.23 1.155.136.954 1.071"
    }, null, -1)
  ]))]))
}
export default { render: render }